import React from "react"
import { Container, Grid } from "@material-ui/core"
import { HeaderHLPure, Question } from "../../pures"
import "./add-survey.css"

const AddSurveyDetailsView = (props) => {
  const {
    catalogInsert,
    questions,
    questionsFunctions,
    transl
  } = props

  const {
    handleChangeQuestion,
    editQuestionOptions,
    changeTypeQuestion,
    deleteQuestion,
    handleChangeQuestionOption,
    handleOptionDropDown,
    createNewQuestion,
    setEditable,
    handleChangeConfig,
    changeQuestionOrder
  } = questionsFunctions

  const { typeQuestion } = catalogInsert

  return (
    <Container disableGutters>
      <Grid container>
        {/* Table and Header */}
        <Grid item xs={12}>
          <HeaderHLPure headingNumber={2} style={{ fontSize: '20px' }} title={transl("questionTitle")} />
        </Grid>

        <Grid item xs={12}>
          {
            questions.map((question, key) => {
              return (
                <Question
                  typeQuestion={typeQuestion}
                  handleChangeQuestion={(ev) => handleChangeQuestion(ev, key)}
                  data={question}
                  id={key}
                  setTypeQuestion={(typeQuestionIdSelected) => changeTypeQuestion(key, typeQuestionIdSelected)}
                  editQuestionOptions={(type, keyOption) => editQuestionOptions(key, type, keyOption)}
                  handleChangeQuestionOption={(keyOption, value) => handleChangeQuestionOption(key, keyOption, value)}
                  handleOptionDropDown={(value) => handleOptionDropDown(key, value)}
                  createNewQuestion={() => createNewQuestion(key)}
                  deleteQuestion={() => deleteQuestion(key)}
                  setEditable={() => setEditable(key)}
                  handleChangeConfig={(ev, keyIdentifier) => handleChangeConfig(key, ev, keyIdentifier)}
                  changeQuestionOrder={(type) => changeQuestionOrder(key, type)}
                  lastQuestion={questions.length - 2}
                />
              )
            })
          }
        </Grid>
      </Grid>
    </Container>
  )
}

export { AddSurveyDetailsView as default }